export default "__VITE_ASSET___oON6ghX__"